var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verdict",class:_vm.tone},[_c('span',{staticClass:"ic"},[_c('i',{staticClass:"fa-solid",class:_vm.icon})]),_c('div',[(_vm.title)?_c('b',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }